/**
 * Chiusura comune a tutte le card della cronologia.
 *
 * Perche' esiste: prima ogni card apriva a modo suo (chi con l'autore, chi con la
 * miniatura, chi col titolo) e in testa aveva un'intestazione con iconcina,
 * tipologia e ora. Il risultato era una colonna che non attaccava mai allo stesso
 * modo. Ora l'anatomia e' una sola:
 *
 *   1. titolo         forte, una riga
 *   2. anteprima      grigia, una o due righe
 *   3. riga sottile   e sotto, a destra, ora e tipologia
 *
 * Il contenuto parte subito in alto a sinistra, dove cade l'occhio, e i dati di
 * servizio (chi, quando, che genere di cosa) chiudono la card come una didascalia.
 * Tenerla in un componente solo e' cio' che garantisce che restino tutte uguali.
 */
import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { kickerCls, formatTime, type CardAccent } from './cardStyles';

interface TimelineFooterProps {
  /** Etichetta della tipologia, in chiaro: "Nota", "Newsletter inviata", "WhatsApp". */
  tipo: string;
  accent: CardAccent;
  /** Data della card. Se `orario` e' passato, vince quello (es. intervallo di sessione). */
  date?: string;
  orario?: string;
  /** Testo esteso mostrato al passaggio del mouse sull'ora. */
  titoloData?: string;
  /** Chip di stato, autore, conteggi: tutto quello che sta a sinistra. */
  left?: React.ReactNode;
  /** Presente solo sulle card che si aprono. */
  expanded?: boolean;
}

export const TimelineFooter: React.FC<TimelineFooterProps> = ({
  tipo,
  accent,
  date,
  orario,
  titoloData,
  left,
  expanded,
}) => {
  const ora = orario ?? (date ? formatTime(date) : '');

  return (
    <div className="mt-2.5 flex items-center gap-2 border-t border-[rgba(55,53,47,0.09)] pt-2 dark:border-[#3F4447]">
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-1.5">{left}</div>
      {ora && (
        <span className="whitespace-nowrap text-[10px] text-[#787774] dark:text-white/50" title={titoloData}>
          {ora}
        </span>
      )}
      <span className={kickerCls(accent)}>{tipo}</span>
      {expanded !== undefined &&
        (expanded ? (
          <ChevronDown size={13} className="shrink-0 text-[#9B9A97] dark:text-white/40" />
        ) : (
          <ChevronRight size={13} className="shrink-0 text-[#9B9A97] dark:text-white/40" />
        ))}
    </div>
  );
};
